export const getUniqueOptions = (arr, key, label) => [
  { value: '', label },
  ...Array.from(new Set(arr.map(item => item[key]))).map(val => ({ value: val, label: val })),
];